module.exports = __webpack_public_path__ + "static/img/sg.40801701.png";